import Container from 'react-bootstrap/Container';
import { Alert, Button, Card, Table, Modal, Accordion } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, CallAPIGet} from '../../services/useBackend';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import React, { useState ,useEffect, useReducer, fetchData, useMemo, useRef} from 'react';
import {MaterialReactTable} from 'material-react-table';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle} from '../../services/misc';
import Test from './editRequestComponent';
import Box from '@mui/material/Box';

function Workflow() {
    const [editRequestModalshow, setEditRequestModalshow] = useState(false);

    const [selectedRequestData, setSelectedRequestData] = useState({Contact: { Name:"N/A"}, RequestWF: [], RequestChilds : [], RequestLog : [], RequestFiles: [], UserID:0 });  
    const [contactData, setContactData] = useState({});

    const {loading:loadingmeta, data:metadata} =  useBackend(process.env.PUBLIC_URL+'/api/meta');    
    const {loading, data, Refresh, Seek} =  useBackend(process.env.PUBLIC_URL+'/api/Workflow/v2');

    const [searchParams] = useSearchParams();
    var pageIndex = parseInt(searchParams.get('pageindex'),10) || 0;
    var pageSize  = parseInt(searchParams.get('pagesize'),10)  || 100;

    const [pagination, setPagination] = useState({ pageIndex: pageIndex, pageSize: pageSize });    

    const navigate = useNavigate();

    useEffect(() => { navigate('?pageindex='+pagination.pageIndex+'&pagesize='+pagination.pageSize) }, [pagination]);

    const editRequestHandler = async (event, rowData)  =>  {
        // var isFullScreen = event.getAttribute("isFullScreen");
        
        // if (!isFullScreen) {
            let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPIGet('/api/requests/' + rowData.original.RequestGuid);
            setSelectedRequestData(jsondata.Request)
            setContactData(jsondata.Request.Contact);
            setEditRequestModalshow(!editRequestModalshow);
        //}        
    }

    var filterSelectOptions = data.filterSelectOptions;
    var filterRequestStates = data.filterRequestStates;

    function getFilterRequestStates() {
        if (data.filterRequestStates == undefined) return [];
        var newArr = [];
        data.filterRequestStates.map((x)=>{ newArr = newArr.concat(x.Title); });
        return newArr;
    }

    function getFilterAssignees() {
        if (metadata.Users == undefined) return [];
        var newArr = [];
        metadata.Users.map((x)=>{ newArr = newArr.concat(x.Name); });
        return newArr;
    }    

    

    const longText = "Det här är en lång text i en liten textbox!!";

    const columns = useMemo(() => [
        { size: 40, accessorKey: 'IndentifierTx',   header: 'Id', enableColumnActions: false, grow: false, size:65 },

        { size: 20, accessorKey:'Date', header: 'Date'        , enableColumnActions: false,  grow: false, size:100,
            Cell: ({ cell }) => SplitoutLocalDateFromISO(cell.getValue()),        
        },

        { size: 40, accessorKey: 'TaskTx',  header: 'Task', filterVariant: 'select', filterSelectOptions: filterSelectOptions },

        { size: 20, accessorKey: 'RequestPriorityItemID', header: 'Priority', enableColumnActions: false,
            Cell: ({ cell }) => ( <span>{metaLookUpTitle(metadata.RequestPriorityItems, cell.getValue())}</span> ),
        }, 

        { size: 20, accessorKey:'RequestsWFStateItemID', header: 'State', filterVariant: 'select', filterSelectOptions: getFilterRequestStates(), enableColumnActions: true,  grow: false, filterFn: 'filterRequestStatesFn',
            Cell: ({ cell }) => metaLookUpTitle(metadata.RequestWFStateItems, cell.getValue())
        },
        
        { accessorKey: 'misc01', header: 'misc01', size: 20, 
            Cell: ({ cell }) => { return <div style={{width:'100px', whiteSpace: 'normal', wordBreak: 'break-word', fontSize:'14px' }}> {cell.getValue()} </div>; },
        },

        { accessorKey: 'misc02', header: 'misc02', size: 20, 
            Cell: ({ cell }) => { return <div style={{width:'100px', whiteSpace: 'normal', wordBreak: 'break-word' }}> {cell.getValue()} </div>; },
        },

        { accessorKey: 'misc03', header: 'misc03', size: 20, 
            Cell: ({ cell }) => { return <div style={{width:'100px', whiteSpace: 'normal', wordBreak: 'break-word' }}> {cell.getValue()} </div>; },
        },

        { accessorKey: 'misc04', header: 'misc04', size: 20, 
            Cell: ({ cell }) => { return <div style={{width:'100px', whiteSpace: 'normal', wordBreak: 'break-word' }}> {cell.getValue()} </div>; },
        },

        { accessorKey: 'misc05', header: 'misc05', size: 20, 
            Cell: ({ cell }) => { return <div style={{width:'100px', whiteSpace: 'normal', wordBreak: 'break-word' }}> {cell.getValue()} </div>; },
        },

        { accessorKey: 'estimatedTime', header: 'Est. Time', size: 20, 
            Cell: ({ cell }) => { return <div style={{width:'100px', whiteSpace: 'normal', wordBreak: 'break-word' }}> {cell.getValue()} </div>; },
        },

        { size: 20, accessorKey:'assignee_id', header: 'Assignee', filterVariant: 'select', filterSelectOptions: getFilterAssignees(), enableColumnActions: true,  grow: false, filterFn: 'filterAssigneeFn',
            Cell: ({ cell }) => metaLookUpTitle(metadata.Users, cell.getValue()),
        },
        
        { accessorKey: 'ContactID', header: 'Customer', filterFn: 'filterCustomerFn',
            Cell: ({ cell }) => { return <div style={{width:'200px', whiteSpace: 'normal', wordBreak: 'break-word' }}> {metaLookUpTitle(metadata.Contacts, cell.getValue())} </div>; },
        },

        { accessorKey: 'RequestTitleTx', header: 'Title',
            Cell: ({ cell }) => { return <div style={{width:'200px', whiteSpace: 'normal', wordBreak: 'break-word' }}> {cell.getValue()} </div>; },
        },
        ]
    );  

    const initialState = { density: 'compact', columnVisibility: { 'estimatedTime':false }, pagination : pagination };    

    const state = { pagination : pagination };      

    if (!loading&&!loadingmeta) {
        return (
            <ContentWrapper>
                <Test RequestData={selectedRequestData} MetaData={metadata} show={editRequestModalshow} fn={()=> {setEditRequestModalshow(!editRequestModalshow); Refresh();} } setSelectedRequestData={setSelectedRequestData} contactData={contactData}/>  
                <Sida>
                    <MaterialReactTable id="Testx" Id="Testx"  columns={columns} data={data.Workflow}  onPaginationChange={setPagination} state={state} initialState={initialState} layoutMode_='grid'
                        style={{overlay: {zIndex: 100}}}
                        muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, rowsPerPageOptions: [25, 50, 75, 100] ,labelRowsPerPage:"Rader"}}
                        renderTopToolbarCustomActions={() => (<Rubrik>Workflow</Rubrik>)}
                        
                        muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                        muiTableBodyRowProps={({ row }) => ({ onClick: (event) => {editRequestHandler(event, row);},sx: {cursor: 'pointer'},})}

                        filterFns={{
                            filterRequestStatesFn: (row, id, filterValue) => {
                                const matchingFilterItem = data.filterRequestStates.filter((r) => r.Title === filterValue)[0];
                                if (row.original.RequestsWFStateItemID == matchingFilterItem.Id) return true;
                                return false;
                            },
                            filterAssigneeFn: (row, id, filterValue) => {
                                const matchingFilterItem = metadata.Users.filter((r) => r.Name === filterValue)[0];
                                if (row.original.assignee_id == matchingFilterItem.Id) return true;
                                return false;
                            },
                            filterCustomerFn: (row, id, filterValue) => {
                                const matchingFilterItems = metadata.Contacts.filter((c) => c.Name.toLowerCase().includes(filterValue.toLowerCase()) );
                                if (matchingFilterItems.find((element) => element.Id === row.original.ContactID)) return true;
                                return false;
                            },                               
                        }}
                    />                                             
                </Sida>
            </ContentWrapper>        
        );
    } else {
        return (<Loading />);        
    }    
}

export default Workflow;